import React from "react";
import {
  FaClock,
  FaMapMarkerAlt,
  FaDollarSign,
  FaCalendarAlt,
  FaTruck,
  FaCheckCircle,
  FaExclamationCircle,
  FaTimesCircle,
} from "react-icons/fa";
import "../styles/OrderDetail.css";

const OrderDetail = ({ order }) => {
  if (!order) return null;

  const getStatusInfo = (status) => {
    switch (status) {
      case 1:
        return {
          icon: <FaExclamationCircle className="status-icon" />,
          text: "Pedido enviado",
          color: "#000000ff",
          bgColor: "#e3f2fd",
        };
      case 2:
        return {
          icon: <FaClock className="status-icon" />,
          text: "En preparación",
          color: "#f39c12",
          bgColor: "#fff3cd",
        };
      case 3:
        return {
          icon: <FaCheckCircle className="status-icon" />,
          text: "Pedido listo",
          color: "#27ae60",
          bgColor: "#d4edda",
        };
      case 5:
        return {
          icon: <FaTimesCircle className="status-icon" />,
          text: "Pedido cancelado",
          color: "#e74c3c",
          bgColor: "#f8d7da",
        };
      default:
        return {
          icon: <FaExclamationCircle className="status-icon" />,
          text: "Estado desconocido",
          color: "#6c757d",
          bgColor: "#f8f9fa",
        };
    }
  };

  const statusInfo = getStatusInfo(order.status);
  const orderDate = new Date(order.production_date);

  return (
    <div className="order-detail-container">
      {/* Header con estado */}
      <div
        className="order-status-header"
        style={{ backgroundColor: statusInfo.bgColor, color: statusInfo.color }}
      >
        <div className="status-content">
          {statusInfo.icon}
          <div>
            <h3 className="status-title">{statusInfo.text}</h3>
            <p className="status-subtitle">
              Pedido #{order.show_order_id || order.id}
            </p>
          </div>
        </div>
      </div>

      {/* Información principal */}
      <div className="order-main-info">
        <div className="info-grid">
          <div className="info-item">
            <div className="info-icon">
              <FaCalendarAlt />
            </div>
            <div className="info-content">
              <span className="info-label">Fecha del pedido</span>
              <span className="info-value">
                {orderDate.toLocaleDateString("es-ES", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">
              <FaClock />
            </div>
            <div className="info-content">
              <span className="info-label">Hora de entrega</span>
              <span className="info-value">{order.end_time}</span>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">
              <FaMapMarkerAlt />
            </div>
            <div className="info-content">
              <span className="info-label">Sucursal</span>
              <span className="info-value">{order.branch_name}</span>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">
              <FaTruck />
            </div>
            <div className="info-content">
              <span className="info-label">Tipo de entrega</span>
              <span className="info-value">
                {parseInt(order.delivery) === 1
                  ? "Delivery"
                  : "Retiro en local"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Detalles del pedido */}
      {order.order_details && order.order_details.length > 0 && (
        <div className="order-items-section">
          <h4 className="section-title">Detalles del pedido</h4>
          <div className="order-items">
            {order.order_details.map((item, index) => (
              <div key={index} className="order-item">
                <div className="item-header">
                  <span className="item-name">{item.product_name}</span>
                  <span className="item-quantity">x{item.quantity}</span>
                </div>

                {item.size && (
                  <div className="item-detail">
                    <span className="detail-label">Tamaño:</span>
                    <span className="detail-value">{item.size}</span>
                  </div>
                )}

                {item.toppings && item.toppings.length > 0 && (
                  <div className="item-detail">
                    <span className="detail-label">Toppings:</span>
                    <span className="detail-value">
                      {item.toppings.join(", ")}
                    </span>
                  </div>
                )}

                {item.extras && item.extras.length > 0 && (
                  <div className="item-detail">
                    <span className="detail-label">Extras:</span>
                    <span className="detail-value">
                      {item.extras.join(", ")}
                    </span>
                  </div>
                )}

                {item.observation && (
                  <div className="item-detail">
                    <span className="detail-label">Observaciones:</span>
                    <span className="detail-value">{item.observation}</span>
                  </div>
                )}

                <div className="item-price">
                  ${parseFloat(item.total_price).toFixed(2)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Total */}
      <div className="order-total">
        <div className="total-content">
          <div className="total-icon">
            <FaDollarSign />
          </div>
          <div>
            <span className="total-label">Total del pedido</span>
            <span className="total-amount">${parseInt(order.total_price)}</span>
          </div>
        </div>
      </div>

      {/* Información adicional */}
      {order.observations && (
        <div className="order-notes">
          <h4 className="section-title">Observaciones</h4>
          <p className="notes-text">{order.observations}</p>
        </div>
      )}
    </div>
  );
};

export default OrderDetail;
